import { IGenericUploadPrepareDto, SimpleResult } from "../dto";
import { Api, getCompanyId } from "../helpers";
import { IGenericUploadPrepResult } from "../models";

export class GenericUploadApi {
  static async prepare({
    body,
    abortController,
  }: {
    body: IGenericUploadPrepareDto;
    abortController?: AbortController;
  }): Promise<SimpleResult<IGenericUploadPrepResult> | undefined> {
    const companyId = getCompanyId();
    const url = `/api/v1/core/c/${companyId}/genericUpload/prepare`;
    const response = await Api.postExtended<
      SimpleResult<IGenericUploadPrepResult>
    >({ url, body, abortController });
    return response?.data;
  }
}
